import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { installNativeShare, isNativeIOS } from '@/utils/capacitorNative';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Solo actúa dentro de la app de iPhone: hoja de compartir nativa + notificaciones push (APNs).
export const NativeAppBridge = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { installNativeShare(); }, []);

  useEffect(() => {
    if (!user || !isNativeIOS()) return undefined;
    const subs = [];
    (async () => {
      const { PushNotifications } = await import('@capacitor/push-notifications');
      subs.push(await PushNotifications.addListener('registration', ({ value }) => {
        axios.post(`${API}/push/apns-token`, { token: value, environment: 'production' }, { withCredentials: true }).catch(() => {});
      }));
      subs.push(await PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
        const url = notification?.data?.url;
        if (url && url.startsWith('/')) navigate(url);
      }));
      const perm = await PushNotifications.requestPermissions();
      if (perm.receive === 'granted') await PushNotifications.register();
    })().catch(() => {});
    return () => subs.forEach((s) => s.remove());
  }, [user, navigate]);

  return null;
};

export default NativeAppBridge;
